<template>
  <!-- 头部导航栏组件 -->
  <header class="header" :class="{ 'header--scrolled': isScrolled }">
    <div class="container">
      <div class="header__content">
        <!-- Logo 区域 -->
        <div class="header__logo" @click="goHome">
          <div class="header__logo-icon">
            <img src="@/static/logo.jpg" alt="米晴科技" class="logo-image" />
          </div>
          <span class="header__logo-text">米晴科技</span>
        </div>

        <!-- 桌面端导航菜单 -->
        <nav class="header__nav desktop-only">
          <router-link
            v-for="item in navItems"
            :key="item.path"
            :to="item.path"
            class="header__nav-item"
            :class="{ 'header__nav-item--button': item.isButton }"
          >
            {{ item.name }}
          </router-link>
        </nav>

        <!-- 移动端菜单按钮 -->
        <div class="header__menu-btn mobile-only" @click="toggleMobileMenu">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>

    <!-- 移动端导航菜单 -->
    <transition name="mobile-menu">
      <div v-if="isMobileMenuOpen" class="header__mobile-menu mobile-only">
        <nav class="header__mobile-nav">
          <router-link
            v-for="item in navItems"
            :key="item.path"
            :to="item.path"
            class="header__mobile-nav-item"
            @click="closeMobileMenu"
          >
            {{ item.name }}
          </router-link>
        </nav>
      </div>
    </transition>
  </header>
</template>

<script>
export default {
  name: 'Header',

  data() {
    return {
      isScrolled: false,
      isMobileMenuOpen: false,
      navItems: [
        { name: '首页', path: '/', isButton: false },
        { name: '产品服务', path: '/products', isButton: false },
        // { name: '场景方案', path: '/solutions', isButton: false },
        { name: '服务案例', path: '/cases', isButton: false },
        { name: '关于我们', path: '/about', isButton: false },
        { name: '合作申请', path: '/apply', isButton: true }
      ]
    }
  },

  mounted() {
    // 监听滚动事件
    window.addEventListener('scroll', this.handleScroll)
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },

  methods: {
    // 处理滚动
    handleScroll() {
      this.isScrolled = window.scrollY > 100
    },

    // 返回首页
    goHome() {
      if (this.$route.path !== '/') {
        this.$router.push('/')
      }
    },

    // 切换移动端菜单
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
    },

    // 关闭移动端菜单
    closeMobileMenu() {
      this.isMobileMenuOpen = false
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  height: $header-height;
  background-color: $bg-white;
  transition: all $transition-normal;
  z-index: $z-index-sticky;

  @include mobile {
    height: 60px;
  }

  &--scrolled {
    box-shadow: $box-shadow-light;
  }

  &__content {
    @include flex-between;
    height: $header-height;

    @include mobile {
      height: 60px;
    }
  }

  // Logo 样式
  &__logo {
    @include flex-center;
    gap: $spacing-sm;
    cursor: pointer;
    transition: transform $transition-normal;

    @include mobile {
      gap: 8px;
    }

    &:hover {
      transform: scale(1.05);
    }
  }

  &__logo-icon {
    width: 55px;
    height: 55px;
    background: linear-gradient(135deg, $primary-color, $primary-hover);
    border-radius: $border-radius-md;
    @include flex-center;

    @include mobile {
      width: 32px;
      height: 32px;
    }

    .logo-image {
      width: 100%;
      height: 100%;
      border-radius: 5px;
      object-fit: contain;
    }
  }

  &__logo-text {
    font-size: $font-size-xl;
    font-weight: 600;
    color: $text-primary;

    @include mobile {
      font-size: $font-size-base;
    }
  }

  // 桌面端导航
  &__nav {
    @include flex-center;
    gap: $spacing-xl;

    @include mobile {
      display: none !important;
    }
  }

  &__nav-item {
    position: relative;
    padding: $spacing-sm 0;
    font-size: $font-size-base;
    font-weight: 500;
    color: $text-primary;
    transition: color $transition-normal;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 0;
      height: 2px;
      background-color: $primary-color;
      transition: width $transition-normal;
    }

    &:hover {
      color: $primary-color;

      &::after {
        width: 100%;
      }
    }

    &.router-link-active {
      color: $primary-color;

      &::after {
        width: 100%;
      }
    }

    // 按钮样式的导航项
    &--button {
      padding: $spacing-sm $spacing-lg;
      background-color: $primary-color;
      color: $bg-white;
      border-radius: 50px;

      &::after {
        display: none;
      }

      &:hover {
        background-color: $primary-hover;
        color: $bg-white;
        transform: translateY(-2px);
        box-shadow: $box-shadow-medium;
      }

      &.router-link-active {
        background-color: $primary-active;
        color: $bg-white;
      }
    }
  }

  // 移动端菜单按钮
  &__menu-btn {
    display: none;
    width: 28px;
    height: 22px;
    flex-direction: column;
    justify-content: space-between;
    cursor: pointer;

    @include mobile {
      display: flex !important;
    }

    span {
      display: block;
      width: 100%;
      height: 2.5px;
      background-color: $text-primary;
      border-radius: 2px;
      transition: all $transition-normal;
    }

    &:hover span {
      background-color: $primary-color;
    }
  }

  // 移动端导航菜单
  &__mobile-menu {
    display: none;
    position: fixed;
    top: 60px;
    left: 0;
    width: 100%;
    height: calc(100vh - 60px);
    background-color: $bg-white;
    box-shadow: $box-shadow-medium;
    z-index: $z-index-fixed;
    overflow-y: auto;

    @include mobile {
      display: block !important;
    }
  }

  &__mobile-nav {
    @include flex-column;
    padding: $spacing-lg;
  }

  &__mobile-nav-item {
    padding: $spacing-lg;
    font-size: $font-size-base;
    font-weight: 500;
    color: $text-primary;
    border-bottom: 1px solid $border-color;
    transition: all $transition-normal;
    text-align: center;

    &:hover {
      color: $primary-color;
      background-color: rgba($primary-color, 0.05);
    }

    &.router-link-active {
      color: $primary-color;
      background-color: rgba($primary-color, 0.1);
      font-weight: 600;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

// 移动端菜单过渡动画
.mobile-menu-enter-active,
.mobile-menu-leave-active {
  transition: all $transition-normal;
}

.mobile-menu-enter-from,
.mobile-menu-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>
